<div class="col-12 text-center">
  <p id="success-connection-message">{{ 'driver_integrated_successfully' | translate }}</p>
  <button class="btn btn-primary" id="continue-btn" (click)="continueHandler()" [disabled]="isInProgress">
    <fa-icon [icon]="['fas','spinner']" class="mr-1" [spin]="true" aria-hidden="true"size="xs" *ngIf="isInProgress"></fa-icon>
    <span>{{ 'continue' | translate }} </span>
  </button>
</div>
